import Link from 'next/link'
import { useEffect, useState } from 'react'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { KeyboardArrowLeft } from '@styled-icons/material-outlined'

import * as S from './styles'
import MediaMatch from '../MediaMatch'
import UserDropdown from 'components/UserDropdown'
import UserIcon from '../UserIcon'
import useAuth from 'hooks/useAuth'
import { routes } from 'core/const/routes'
import MenuStep from 'components/MenuStep'
import config from 'config'
import MenuMobileApp from '../MenuMobileApp'
import Button from '../Button'
import IconTutorial from '../../../../public/img/menu/icon-tutorial.svg'
import { useJoyrideContext } from 'contexts/JoyrideTour/JoyrideTourContext'
import * as Analytics from 'utils/analyticsevents'

const stepsTutorialDesktop = [
  {
    target: '.passo-menudkt-meus-ambientes',
    title: 'Aqui você encontrará as consultorias contratadas',
    content:
      'Todos os ambientes em um lugar único, além de visualizar etapas de cada consultoria e os passos necessários.',
    disableBeacon: true
  },
  {
    target: '.passo-menudkt-presentes',
    title: 'Receba e veja consultorias de presentes enviados no seu perfil',
    content:
      'Caso tenha recebido um presente venha até aqui para aceitar o seu presente e começar a transformar o seu ambiente!',
    disableBeacon: true
  },
  {
    target: '.passo-menudkt-cupons',
    title:
      'Cupons exclusivos de lojas parceiras para você economizar na sua compra',
    content:
      'Transforme seu ambiente com AB economizando no design de ambiente até a compra dos produtos.',
    disableBeacon: true
  },

  {
    target: '.passo-menudkt-faq',
    title: 'Aqui você encontrará a resposta para as perguntas mais frequentes',
    content:
      'Nosso time preparou todas as respostas com muito carinho para te auxiliar na jornada da sua transformação.',
    disableBeacon: true
  },
  {
    target: '.passo-menudkt-assistenteab',
    title:
      'Assistente 24h por inteligência artificial exclusiva para clientes Premium',
    content:
      'Tire dúvidas sobre reforma e decoração com nosso assistente personalizado.',
    disableBeacon: true
  },
  {
    target: '.passo-consultoria',
    title: 'Aqui você encontrará as consultorias contratadas',
    content:
      'Todos os ambientes em um lugar único, além de visualizar etapas de cada consultoria e os passos necessários.',
    disableBeacon: true
  },
  {
    target: '.passo-menu-rodape',
    title: 'Informações e Links Úteis',
    content:
      'Aqui você encontra as informações de contato do nosso time de Felicidade do Cliente e seu horário de atendimento.',
    disableBeacon: true
  }
]

export type MenuProps = {
  avancar?: number
  material?: boolean
  plantaTecnica?: boolean
  cloneConsultoria?: boolean
  setAvancar?: (value: number) => void
  activeLink?:
    | '/resgate-saldo'
    | '/minhas-consultorias'
    | '/presentes'
    | '/cupons'
    | '/minhas-consultorias/consultoria'
    | string
  possuiConsultoriaPremium?: boolean
}

const Menu = ({
  activeLink,
  plantaTecnica,
  cloneConsultoria,
  avancar,
  setAvancar,
  material,
  possuiConsultoriaPremium
}: MenuProps) => {
  const { usuario } = useAuth()
  const [urlIndex, setUrlIndex] = useState('')
  const reduzirNomeUsuario = avancar ? true : false
  const router = useRouter()
  const { setRun, setSteps } = useJoyrideContext()

  const handleClickStartTutorialDesktop = () => {
    setRun(true)
    let validSteps = stepsTutorialDesktop

    if (!possuiConsultoriaPremium) {
      validSteps = removeStepByTarget(validSteps, '.passo-menudkt-assistenteab')
    }

    if (router.pathname !== routes.minhasConsultorias) {
      validSteps = removeStepByTarget(validSteps, '.passo-consultoria')
    }

    setSteps(validSteps)
  }

  const removeStepByTarget = (steps, targetToRemove) => {
    return steps.filter((step) => step.target !== targetToRemove)
  }

  function verificaUrlIndex() {
    const caminho = activeLink?.split('?')
    if (caminho) setUrlIndex(caminho[0])
  }

  useEffect(() => {
    verificaUrlIndex()
  }, [])

  return (
    <>
      <MediaMatch greaterThan="large" large>
        <S.ContainerMenu>
          <S.Wrapper>
            {avancar ? (
              <div style={{ width: '100%' }}>
                <MediaMatch greaterThan="large">
                  <div className="d-flex">
                    {usuario?.perfil != config.PERFIL_EXTERNO && (
                      <>
                        {avancar > 1 && avancar < 11 && (
                          <S.BotaoVoltar
                            aria-label="Botão voltar"
                            onClick={() =>
                              setAvancar && setAvancar(avancar - 1)
                            }
                          >
                            <KeyboardArrowLeft size={42} color={`#7F0BA4`} />
                          </S.BotaoVoltar>
                        )}
                      </>
                    )}

                    {avancar && !plantaTecnica && !cloneConsultoria && (
                      <MenuStep avancar={avancar} material={material} />
                    )}
                    {avancar && plantaTecnica && (
                      <MenuStep
                        avancar={avancar}
                        plantaTecnica={plantaTecnica}
                      />
                    )}
                    {avancar && cloneConsultoria && !plantaTecnica && (
                      <MenuStep
                        avancar={avancar}
                        cloneConsultoria={cloneConsultoria}
                      />
                    )}
                  </div>
                </MediaMatch>
              </div>
            ) : (
              <MediaMatch greaterThan="large">
                <S.MenuNav className="gtm-app-header-menu">
                  <Link
                    href={routes.minhasConsultorias}
                    passHref
                    title="Meus ambientes"
                  >
                    <S.MenuLink
                      className="passo-menudkt-meus-ambientes"
                      isActive={
                        activeLink === routes.minhasConsultorias ||
                        routes.consultoriaDetalhes === urlIndex
                      }
                      title="Meus ambientes"
                      onClick={() =>
                        Analytics.gtmHeaderMenu({
                          click_text: 'Meus ambientes'
                        })
                      }
                    >
                      Meus ambientes
                    </S.MenuLink>
                  </Link>
                  {usuario?.perfil != config.PERFIL_EXTERNO && (
                    <Link href={routes.presentes} passHref title="Presentes">
                      <S.MenuLink
                        className="passo-menudkt-presentes"
                        isActive={activeLink === routes.presentes}
                        title="Presentes"
                        onClick={() =>
                          Analytics.gtmHeaderMenu({ click_text: 'Presentes' })
                        }
                      >
                        Presentes
                      </S.MenuLink>
                    </Link>
                  )}
                  {usuario?.perfil != config.PERFIL_EXTERNO && (
                    <Link href={routes.cupons} passHref title="cupons">
                      <S.MenuLink
                        className="passo-menudkt-cupons"
                        isActive={activeLink === routes.cupons}
                        title="Cupons"
                        onClick={() =>
                          Analytics.gtmHeaderMenu({ click_text: 'Cupons' })
                        }
                      >
                        Cupons
                      </S.MenuLink>
                    </Link>
                  )}

                  <Link
                    href="https://arquitetodebolso.com.br/perguntas-frequentes/"
                    passHref
                    title="Faq"
                    target="_blank"
                  >
                    <S.MenuLink
                      isActive={activeLink === routes.faq}
                      className="passo-menudkt-faq"
                      onClick={() =>
                        Analytics.gtmHeaderMenu({ click_text: 'Dúvidas' })
                      }
                    >
                      Dúvidas
                    </S.MenuLink>
                  </Link>
                  {possuiConsultoriaPremium && (
                    <Link
                      href="https://bit.ly/assistente-ab"
                      passHref
                      title="Assistente Virtual do AB"
                    >
                      <S.MenuLink
                        target="_blank"
                        rel="noopener noreferrer"
                        className="passo-menudkt-assistenteab"
                        onClick={() =>
                          Analytics.gtmHeaderMenu({
                            click_text: 'Assistente Virtual do AB'
                          })
                        }
                      >
                        Assistente Virtual do AB
                      </S.MenuLink>
                    </Link>
                  )}

                  {usuario?.perfil == config.PERFIL_EXTERNO && (
                    <Link
                      href="https://aprenda.arquitetodebolso.com.br/courses?showcase=3"
                      passHref
                      title="Treinamento"
                    >
                      <S.MenuLink
                        target="_blank"
                        onClick={() =>
                          Analytics.gtmHeaderMenu({ click_text: 'Treinamento' })
                        }
                      >
                        Treinamento
                      </S.MenuLink>
                    </Link>
                  )}

                  {usuario?.perfil == config.PERFIL_CLIENTE && (
                    <Button
                      size="medium"
                      buttonAround
                      colorButton="#833D90"
                      icon={
                        <Image
                          src={IconTutorial}
                          width={13}
                          height={13}
                          alt="Ícone de tutorial"
                        />
                      }
                      style={{ padding: '1rem 1.5rem' }}
                      onClick={() => {
                        Analytics.gtmHeaderMenu({ click_text: 'Tutorial' })
                        handleClickStartTutorialDesktop()
                      }}
                    >
                      <span style={{ marginLeft: '5px' }}>Tutorial</span>
                    </Button>
                  )}
                </S.MenuNav>
              </MediaMatch>
            )}

            <S.MenuGroup>
              <MediaMatch greaterThan="large">
                <UserDropdown reduzirNomeUsuario={reduzirNomeUsuario} />
              </MediaMatch>
              <MediaMatch lessThan="large">
                <UserIcon />
              </MediaMatch>
            </S.MenuGroup>
          </S.Wrapper>
        </S.ContainerMenu>
      </MediaMatch>

      <MediaMatch lessThan="large" large>
        <MenuMobileApp
          activeLink={activeLink}
          possuiConsultoriaPremium={possuiConsultoriaPremium}
        />
      </MediaMatch>
    </>
  )
}

export default Menu
